import { query as firebaseQuery, onValue } from "firebase/database";
import { useCallback, useState, useSyncExternalStore } from "react";
import { ref } from "../index.js";
export const useValue = (...path) => (options = {}) => {
    const [state, setState] = useState({
        isFetched: false,
    });
    // biome-ignore lint/correctness/useExhaustiveDependencies: Unstable dependencies
    const subscribe = useCallback(() => {
        if (options.disabled) {
            return () => { };
        }
        const dbRef = ref(...path);
        const query = options.query?.(dbRef) ?? dbRef;
        return onValue(options.queryConstraints?.length
            ? firebaseQuery(query, ...options.queryConstraints)
            : query, (snapshot) => {
            setState(({ data }) => {
                try {
                    return {
                        data: options.onSuccess?.(snapshot, data) ??
                            options.schema?.parse(snapshot.val()) ??
                            snapshot.val(),
                        isFetched: true,
                    };
                }
                catch (error) {
                    return {
                        data: options.onError?.(error, snapshot, data) ?? data,
                        isFetched: true,
                    };
                }
            });
        }, (error) => {
            console.error(2, error);
        });
    }, [
        options.disabled,
        options.onSuccess,
        options.query,
        ...(options.queryConstraints || []),
        ...path,
    ]);
    useSyncExternalStore(subscribe, () => state);
    return state;
};
//# sourceMappingURL=useValue.js.map